export default __webpack_public_path__ + "static/media/straightbaguette-reversed.f7bed3a7.svg";